import cancellableFetchFromStore from '@/utils/functions/analytics/cancellableFetch/fromStore'
import { TAB_USAGE } from '@/components/layouts/metrics/program/Bar.vue'

// import payload from '@/utils/mocked-data/metrics/program/charts/activity'

export const fetch = function(ctx) {
  return cancellableFetchFromStore({
    ctx,
    store: this,
    tab: TAB_USAGE,
    proxy: {
      method: 'post',
      path:
        '/internal_api/sas_bo_front_end/v1/programs_metrics/charts/activity',
      data: ctx.rootGetters['metrics/program/paramsForBackend']
    }
  })
}

export const refresh = fetch
